export const PH_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
export const PH_CONFIG = {
  api_host: "https://us.i.posthog.com",
  person_profiles: "identified_only",
  opt_out_capturing_by_default: (() => {
    if (typeof window === "undefined") return true;
    try {
      return localStorage.getItem("cookie-consent") !== "accepted";
    } catch (e) {
      return true;
    }
  })(),
  session_recording: { recordCrossOriginIframes: false, capturePerformance: false },
};
